import { render, staticRenderFns } from "./Ensambles.vue?vue&type=template&id=7c206856&"
import script from "./Ensambles.vue?vue&type=script&lang=js&"
export * from "./Ensambles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports